(function() { module.exports = this["ReactDOM"]; }());


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 8
// module chunks = 0